import React from 'react';
import { useTranslation } from 'react-i18next';

import { formatTicketPrize } from '../../utils/formatters';

import { isDefault, isTemplateZeta } from '../../utils/template';

import Matches from './elements/Matches';

function Prizes({ lotterySlug, prizes }) {
    const { t } = useTranslation();

    function getMatches(prize) {
        const matches = JSON.parse(prize.matches);

        if (typeof matches !== 'undefined') {
            return (
                <div key={`prize${prize.id}`}>
                    <div className="row no-gutters row-match font-bold">
                        <div className="col align-self-end">
                            <Matches matches={matches} lotterySlug={lotterySlug} />
                        </div>
                        <div className="col text-right col-right align-self-end">
                            {isTemplateZeta() ? (
                                <p className={`jackpot-amount-small font-black currency-${prize.currency_code}`}>
                                    {!prize.name
                                        ? formatTicketPrize(prize.per_user_gross, prize.currency_code)
                                        : `${prize.count} x ${prize.name}`}
                                </p>
                            ) : (
                                <p className={`jackpot-amount-small font-black currency-${process.env.MIX_CURRENCY}`}>
                                    {!prize.name
                                        ? formatTicketPrize(prize.per_user_gross)
                                        : `${prize.count} x ${prize.name}`}
                                </p>
                            )}
                            <p className="name">
                                {prize.lines_won_count} {t('prizes.winners')}
                            </p>
                        </div>
                    </div>
                    <div className="line" />
                </div>
            );
        }
        return null;
    }

    function getDefaultMatches(prize) {
        const matches = JSON.parse(prize.matches);

        if (typeof matches !== 'undefined') {
            return (
                <div key={`prize${prize.id}`}>
                    <div className="prize-breakdown d-flex justify-content-between align-items-center">
                        <div className="matches-container">
                            <Matches matches={matches} lotterySlug={lotterySlug} />
                        </div>
                        <div className="prize-container d-flex flex-column align-items-end">
                            <p className={`jackpot-amount-small font-black currency-${process.env.MIX_CURRENCY}`}>
                                {!prize.name
                                    ? formatTicketPrize(prize.per_user_gross)
                                    : `${prize.count} x ${prize.name}`}
                            </p>
                            <p className="name">
                                {prize.lines_won_count} {t('prizes.winners')}
                            </p>
                        </div>
                    </div>
                    <div className="line" />
                </div>
            );
        }
        return null;
    }

    const renderPrizeName = () => (
        <p className={`prizebd-name font-bold ${isDefault() ? 'text-center' : ''}`}>{t('prizes.prizeBreakdown')}</p>
    );

    const renderPrizes = () => {
        if (isDefault()) {
            return (
                <div className="prizebd-wrapper d-flex flex-column">
                    {prizes.map((prize) => getDefaultMatches(prize))}
                </div>
            );
        }
        return prizes.map((prize) => getMatches(prize));
    };

    return (
        <div className={`prizebd ${isDefault() ? 'container g-0' : 'container-small'}`}>
            {renderPrizeName()}
            {renderPrizes()}
        </div>
    );
}

export default Prizes;
